<template>
  <template v-if="stip.stipulationStatusId === StipulationStatusIds.OPEN">
    <template v-if="measureOneEnabled">
      <div class="button-container">
        <next-button class="w-100" @click="openMeasureOneLinkWidget" :text="'Start Verification'" />
      </div>
      <MeasureOneModal
       	v-if="showMeasureOneModal"
        ref="measureOneModalRef"
        :lenderId="lenderId"
        :applicant="applicant"
        :stip="stip"
        @success="emit('success')"
        @datasourceConnected="handleConnection"
        @confirmManualCertification="confirmManualCertification"
				@close="showMeasureOneModal = false"
      />
      <div class="link-container mt-11">
        <a class="text-decoration-underline" @click="confirmManualCertification"
          >Click here to submit income documents instead</a
        >
      </div>
      <ConfirmManualncomeVerificationModal
        ref="modalRef"
        :stip="stip"
        :applicant="applicant"
        :manualCertification="manualCertification"
        @close="closeModal"
      />
    </template>
    <template v-else>
      <div>MeasureOne is not enabled for this lender</div>
    </template>
  </template>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useStore } from "vuex";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import ConfirmManualncomeVerificationModal from "@/components/modals/ConfirmManualncomeVerificationModal.vue";
import MeasureOneModal from "@/components/modals/MeasureOneModal.vue";
import { StipulationStatusIds } from "@/config/constants";
import NextButton from "@/components/shared/NextButton.vue";

interface Props {
  stip: Stipulation;
  applicant: Applicant;
}

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits<{
  (event: "success"): void;
}>();

const store = useStore();
const lenderId = computed<number>(() => store.state.appData?.application?.lenderId);

const modalRef = ref<InstanceType<typeof ConfirmManualncomeVerificationModal> | null>();
const measureOneModalRef = ref<InstanceType<typeof MeasureOneModal> | null>();

const showMeasureOneModal = ref<boolean>(false);
const manualCertification = ref<boolean>(false);
const measureOneEnabled = computed<boolean>(() => store.state.configuration?.measureOneEnabled);

const handleConnection = (event: any) => {
  console.log("Parent component received connection event:", event);
  // Perform actions like redirecting the user or displaying a success message
};

const openMeasureOneLinkWidget = () => {
  showMeasureOneModal.value = true;
};

function confirmManualCertification() {
  if (measureOneModalRef.value) {
    measureOneModalRef.value?.closeModal();
  }

  manualCertification.value = true;
  modalRef.value?.openModal();
}

function closeModal() {
  modalRef.value?.closeModal();
}
</script>

<style scoped src="@/styles/measure-one-modal/m1-modal.css"></style>
